import React, { useEffect } from "react";
import { notification } from "antd";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";

import { REINIT_ALERT_MESSAGE } from "../../store/actions/actions";
import { AppPathNames } from "@/constants/AppPathNames";

const openNotification = (message, type, description = "") => {
  notification[type]({
    message,
    description,
  });
};

const AjaxResponseHandler = (props) => {
  useEffect(() => {
    if (props.message) {
      openNotification(props.message, "success", props.description);
    }
    if (props.error) {
      openNotification(props.errorTitle, "error", props.error);
    }
    if (props.info) openNotification(props.info, "info");

    return () => {
      props.reinit();
    };
  }, [props.message, props.error, props.info, props.pageNotFound, props.description, props]);

  return <>{props.pageNotFound && <Navigate push to={AppPathNames.pageNotFound} />}</>;
};
const mapDispathToProps = (dispatch) => {
  return {
    reinit: () => dispatch({ type: REINIT_ALERT_MESSAGE }),
  };
};

const mapStateToProps = (state) => {
  return {
    error: state.alert.error,
    errorTitle: state.alert.errorTitle,
    message: state.alert.message,
    description: state.alert.description,
    info: state.alert.info,
    pageNotFound: state.alert.pageNotFound,
  };
};

export default connect(mapStateToProps, mapDispathToProps)(AjaxResponseHandler);
